<template>
<v-row>
  <v-alert v-if="moreSearchResults" class="mx-2 py-1" type="error" text prominent color="opportunity">Warning: Your search came back with too many results to display. Refine your search and try again.</v-alert>
  <v-col v-for="result in searchResults" :key="result.id" cols="12" xl="4" md="6" class="py-0">
    <SearchResult :client="result" class="my-2" />
  </v-col>
</v-row>
</template>

<script>
import SearchResult from './SearchResult';
import { mapState } from 'vuex';

export default {
  name: 'SearchResultsWrapper',
  components: {
    SearchResult
  },
  computed: {
    ...mapState('search', ['searchResults', 'moreSearchResults'])
  }
};

</script>
